require('../common/facets.js');
import {commonSearch} from '../common/commonSearch.js';
import {fieldDisplay} from '../common/fieldDisplay.js';
import {pushState} from '../common/pushState.js';

require ('../common/jquery.scroller.js');
require ('../common/jquery.paginator.js');
const Cookies = require('js-cookie');

import {page} from '../common/common.js';
import {init} from '../common/init.js';

(function ($) {

	var container = null,
		defaultSearch = {
			q: '',
			searchType: 'all',
			filters: {},
			page: 1
		},
		pageSize = 50;

	function cleanUpFieldNames(doc) {
		var keys = Object.keys(doc),
			cleanKey,
			cleanDoc = {};
		$.each(keys, function (i, key) {
			cleanKey = key.replace(/^s_/, '');
			cleanKey = cleanKey.replace(/_.*$/, '');
			// console.log(key + '  ' +cleanKey);
			cleanDoc[cleanKey] = doc[key];
		});
		return cleanDoc;
	}

	window.handlePageState = function (state) {
		if (HF_GLOBALS.debug) console.log('pagestate');
		return performSearch(state ? state.query : {}, false, true, false);
	};

	function showSpellingSuggestions(spellcheck) {
		container.find('.spelling').empty();
		// if (spellcheck.correctlySpelled) {
		//     return;
		// }
		$.each(spellcheck.collations, function (index, collation) {
			container.find('.spelling')
				.append('Did you mean ')
				.append($('<a/>').text(collation.collationQuery).on('click', function () {
					performSearch({
						initialSearch: true,
						q: collation.collationQuery
					});
				})).append(` (${collation.hits})?`);
			return false;
		});
	}

	function showSearchResults(searchData, suffix) {
		const res = searchData.res,
			listContainer = container.find('.results .list'),
			//newList = $('<div/>').addClass('list'),
			results = container.find('.results').addClass('empty').removeClass('masonry_fixed');
		let dfd = new $.Deferred(),
			currentPos = 0;
		$('.searchBar').searchForm('setSearchData', {
			q: searchData.q,
			searchType: searchData.searchType
		});

		if (container.find('.filter.genre .list').hasClass('scroller-initiailzed')) {
			container.find('.filter.genre .list').scroller('destroy');
		}
		container.find('.filter').trigger('update', [res, searchData.filters]);
		container.find('.filter.genre .list').scroller();

		if (Object.keys(searchData.filters).filter(name => name != 'genre').length) {
			container.find('.filters').addClass('hasFilters');
		} else {
			container.find('.filters').removeClass('hasFilters');
		}

		if (res?.spellcheck) {
			showSpellingSuggestions(res.spellcheck);
		}
		if (res?.response == null || res.response.numFound == 0) {
			results.trigger('destroyPagination');
			listContainer.empty().append($('<span/>').addClass('noValue').text(
				'No results match your query'));
			dfd.resolve();
		} else {
			let deferreds = [];
			results.removeClass('empty');
			results.data({
				start: res.response.start,
				numResults: res.response.numFound,
				page: searchData.page
			});

			results.paginator({
				currentPage: (res.response.start / pageSize) + 1,
				totalPages: Math.ceil(res.response.numFound / pageSize),
				totalRecords: res.response.numFound,
				perPage: pageSize,
				objName: 'match',
				objNamePlural: 'matches',
				getExtraInfo: function () {
					return commonSearch.getMltDescription(searchData.paginationInfo);
				},
				style: 'textbox',
				clickHandler: function (newPage) {
					performSearch($.extend(searchData, {
						initialSearch: false,
						page: newPage,
						res: null
					}), true);
				}
			});

			listContainer.empty();
			$.each(res.response.docs, function (index, doc) {
				let placeHolder = $('<div/>').addClass('result');
				listContainer.append(placeHolder);
				deferreds.push(
					commonSearch.getResult(doc, res.hasOwnProperty('highlighting') ? res.highlighting[
						doc.id] : null, suffix).done(function (result) {
						placeHolder.replaceWith(result);
						commonSearch.truncateExcerpt(result);
					})
				);
			});
			$.when.apply(null, deferreds).always(function () {
				if (HF_GLOBALS.debug) console.log('results Drawn');
				dfd.resolve();
			});
		}
		return dfd.promise();
	}

	function performSearch(searchData, inheritFilters, useStoredResult, updateHistory) {
		var dfd = new $.Deferred(),
			suffix = $('.suffix input:checked').val(),
			listContainer = container.find('.results .list'),
			data = {},
			filtersList,
			hasPaginationInfo = searchData?.paginationInfo ? true :false;

		inheritFilters = inheritFilters == undefined ? true : inheritFilters;
		useStoredResult = useStoredResult == undefined ? false : useStoredResult;
		updateHistory = updateHistory == undefined ? true : updateHistory;

		if (searchData.res && useStoredResult) {
			if (HF_GLOBALS.debug) console.log('showing stored result');
			$.when(showSearchResults(searchData, suffix)).always(function() {
				dfd.resolve();
			});
		}
		searchData.res = null;

		if (inheritFilters) {
			searchData.filters = $.extend(history.state.query.filters, searchData.filters);

		} else {
			if (!searchData.hasOwnProperty('filters')) {
				searchData.filters = {};
			}
		}

		//remove empty filters
		Object.keys(searchData.filters).forEach((k) => !searchData.filters[k] && delete searchData.filters[
			k]);
		

		searchData = $.extend({}, history.state.query, searchData);
		if (!hasPaginationInfo) {
			searchData.paginationInfo = null;
		}

		if (HF_GLOBALS.debug) console.log('performSearch', searchData);

		data = $.extend({}, {
			q: searchData.q,
			initialSearch: searchData.initialSearch,
			searchType: searchData.searchType,
			start: (searchData.page - 1) * pageSize,
			fq: commonSearch.getFq(searchData.filters),
			suffix: suffix,
			paginationInfo: {}
		});
		container.find('.results').waitingBox();
		$.ajax({
			container: container,
			url: 'newsearch/',
			data: $.param(data, true),
			dataType: 'json',
			method: 'GET'
		}).done(function (res) {
			//currentSearch = searchData;
			var row = null,
				index = 0;
			if (HF_GLOBALS.debug) console.log('main Search', res);
			listContainer.trigger('destroyPagination');
			if (!res || res.error) {
				listContainer.empty().prepend($('<span/>').addClass('noValue error').text(
					'There was an error executing your query. ' + (res && HF_GLOBALS.debug ? res.error.msg : '')));
				dfd.reject();
				return;
			}
			searchData.res = res;
			$.when(commonSearch.getMltMatchInfo(searchData)).done(function (data) {
				searchData.paginationInfo = data;
				if (updateHistory) {
					pushState.updateState({
						query: searchData
					});
				} else {
					history.replaceState($.extend(history.state, {
						query: searchData
					}), null);
				}
				if (HF_GLOBALS.debug) console.log(searchData, history.state.query);
				$.when(showSearchResults(searchData, suffix)).always(function() {
					$('html').scrollTop(0);
					dfd.resolve();
				});
			
			});

		}).fail(function () {
			listContainer.empty().prepend($('<span/>').addClass('noValue error').text(
				'There was an error executing your query.'));

			dfd.reject();
		}).always(function() {
			container.find('.results').trigger('stopWaiting');
		});

		return dfd.promise();

	}

	function integrateHighlighting(doc, highlighting) {
		if (highlighting.description) {
			doc.description = highlighting.description;
		}
		const logFields = [{
			highlightField: 'descriptions',
			logField: 'description'
		}, {
			highlightField: 'songTitles',
			logField: 'title'
		}, {
			highlightField: 'artitsts',
			logField: 'artist'
		}];

		logFields.forEach((field) => {

			if (highlighting[field.highlightField]) {
				highlighting[field.highlightField].forEach(desc => {
					var match = desc.match(/^\{(\d+)\}_\s(.*)/s);
					if (match) {
						var id = match[1],
							highlightedVal = match[2];

						doc.log['desc' + id][field.logField] = highlightedVal;
					}
				});
			}
		});

		return doc;
	}

	function toggleFilterVisibility(value) {
		value = value == undefined ? $('body').hasClass('filtersClosed') : value;
		container.one('transitionend', function () {
			container.find('.filter.genre .list').scroller('handleResize');
		});
		container.toggleClass('filtersClosed', !value);
		$('body').toggleClass('filtersClosed', !value);
		Cookies.set('showSearchFilters', value);
		if (value && window.innerWidth > 640) {
            $(document).scrollTop(0);
        }
	}

	function initFilters() {

		container.find('.filter.specialty').toggleFacet({
			fieldName: 'specialtyCollection',
			displayName: 'Hide Specialty Collections',
			defaultValue: false,
			tag: 'specialty',
			offValue: "true",
			invert: true,
			callback: function (value) {
				performSearch({
					initialSearch: false,
					filters: {
						specialty: value ? $.extend({}, commonSearch.filterSettings.specialty, {
							value: !value
						}) : null
					},
					page: 1
				});
			}
		});

		container.find('.filter.offline').toggleFacet({
			fieldName: 'hasVideo',
			displayName: 'Hide Offline Footage',
			defaultValue: false,
			tag: 'online',
			offValue: "false",
			invert: true,
			callback: function (value) {
				performSearch({
					initialSearch: false,
					filters: {
						online: value ? $.extend({}, commonSearch.filterSettings.online, {
							value: value
						}) : null
					},
					page: 1
				});
			}
		});

		container.find('.filter.genre').listFacet({
			fieldName: 'genre',
			tag: 'genre',
			selectedClass: 'selected',
			selectedList: true,
			drawItem: function (value, count) {
				var facet = $('<div/>').addClass('facet').addClass(function () {

						if (history.state.query.filters?.genre &&
							history.state.query.filters.genre.value.indexOf(value) != -1) {
							return 'selected';
						}
					}).data('value', value)
					.append($('<span/>').addClass('name').html(fieldDisplay.displayField(value)))
					.append($('<span/>').addClass('count').html(fieldDisplay.displayField(count)));
				return facet;
			},
			callback: function (value) {
				performSearch({
					initialSearch: false,
					filters: {
						genre: value && value.length ? $.extend({}, commonSearch.filterSettings.genre, {
							value: value
						}) : null
					},
					page: 1
				});
			}
		});

		container.find('.filter.color').listFacet({
			fieldName: 'color',
			tag: 'color',
			selectedClass: 'selected',
			drawItem: function (value, count) {
				const selected = history.state.query.filters?.color &&
					history.state.query.filters.color.value.indexOf(value) != -1;
				return $('<div/>').addClass('facet').addClass(function () {

						if (selected) {
							return 'selected';
						}
					}).data('value', value)
					.append($('<label/>')
						.append($('<input type="checkbox"/>').prop('checked', selected).prop('disabled', count ==
							0))
						.append($('<span/>').addClass('name').html(fieldDisplay.displayField(value)))
						.append($('<span/>').addClass('count').html(fieldDisplay.formatNumber(count)))
					);
			},
			callback: function (value) {
				performSearch({
					initialSearch: false,
					filters: {
						color: value && value.length ? $.extend({}, commonSearch.filterSettings.color, {
							value: value
						}) : null
					},
					page: 1
				});
			},
			forceList: {
				"Black & White": 0,
				Color: 0
			}
		});

		container.find('.filter.date').textboxRangeFacet({
			field1: 'yearStart',
			field1Label: 'From: ',
			field2: 'yearEnd',
			field2Label: 'To: ',
			tag: 'year',
			numeric: true,
			callback: function (value) {
				performSearch({
					initialSearch: false,
					filters: {
						year: value && (value.yearStart || value.yearEnd) ? $.extend({}, commonSearch.filterSettings.year, {
							value: value
						}) : null
					},
					page: 1
				});
			}
		});

		container.find('.filter.resolution').sliderRangeFacet({
			fieldName: 'resolution',
			range: {
				res480: {
					value: 4,
					label: 'Any',
					dataval: 480
				},
				res720: {
					value: 3,
					label: 'HD 720 or higher',
					dataval: 720
				},
				res1080: {
					value: 2,
					label: 'HD 1080 or higher',
					dataval: 1080
				},

				res4096: {
					value: 1,
					label: '4k or higher',
					dataval: 2160
				}
			},
			defaultDataVal: 480,
			defaultVal: 4,
			tag: 'res',
			callback: function (value) {
				performSearch({
					initialSearch: false,
					filters: {
						res: value ? $.extend({}, commonSearch.filterSettings.res, {
							value: value
						}) : null
					},
					page: 1
				});
			}
		});

		container.find('.filters .toggle').click(function () {
			toggleFilterVisibility();
		});
		container.find('.filters .btnClearFilters').click(function () {
			performSearch({
				initialSearch: false,
				page: 1,
				filters: history.state.query.filters.genre ? {
					genre: history.state.query.filters.genre
				} : {},
				q: history.state.query.q,
				searchType: history.state.query.searchType
			}, false);
		});
	}

	window.initPage = function () {
		if (HF_GLOBALS.debug) console.log('initpage -- search');
		container = $("#searchContainer");

		 $(document).on('touchstart', '.results .result .resultLink', function(e) {
            let el = $(this);
            $('.results .result .resultLink').not(this).removeClass('touched').removeClass('ready');
            //el.addClass('ready');
            el.hoverVideoPlayer('stopPlayer');
        });

        $(document).on('click', '.results .result .resultLink', function(e) {
            let link = $(this),
                result = link.parent();
            e.preventDefault();
            e.stopPropagation();

            // if (result.hasClass('hasVideo') && link.hasClass('touched')) {
            //     if (!link.hasClass('ready')) {
            //         link.addClass('ready');
            //     } else {
            //         commonSearch.showResult(result);
            //     }
            //     return false;
            // } else {
                commonSearch.showResult(result);
            //}
            return false;
        });
		toggleFilterVisibility(Cookies.get('showSearchFilters') == 'true');
		initFilters();


		page.performSearch = performSearch;
		page.integrateHighlighting = integrateHighlighting;
	};

	init.init();
	$(document).ready(function() {
		init.initPage();
	})

})(jQuery);
